import {
  GET_COMPANY_STRUCTURE,
  SEARCH_COMPANY_STRUCTURE,
  GET_PERSON_DETAILS,
  GET_PERSON_DETAILS_REQUEST,
  GET_PERSON_EDIT_DATA,
  UPDATE_PERSON_HIERARCHY,
  GET_PERSON_HISTORY,
  CLEAR_PERSON_EDIT_DATA,
  SUCCESS,
  FAIL,
} from "../action_types";

const STATE_INIT = {
  isHierarchyLoading: false,
  isPersonDetailsLoading: false,
  isPersonEditDataLoading: false,
  isPersonHistoryLoading: false,
  isSearching: false,
  isUpdating: false,
  hierarchy: [],
  outlets: [],
  searchResults: [],
  selectedPerson: null,
  editData: null,
  personHistory: [],
  updateResult: null,
  error: {},
};

export default (state = STATE_INIT, { type, payload }) => {
  switch (type) {
    case GET_COMPANY_STRUCTURE:
      return { ...state, isHierarchyLoading: true };
    case `${GET_COMPANY_STRUCTURE}_${SUCCESS}`:
      return {
        ...state,
        isHierarchyLoading: false,
        hierarchy: payload?.hierarchy || [],
        outlets: payload?.outlets || [],
      };
    case `${GET_COMPANY_STRUCTURE}_${FAIL}`:
      return { ...state, isHierarchyLoading: false, error: { ...payload } };

    case SEARCH_COMPANY_STRUCTURE:
      return { ...state, isSearching: true };
    case `${SEARCH_COMPANY_STRUCTURE}_${SUCCESS}`:
      return {
        ...state,
        isSearching: false,
        searchResults: payload?.results || [],
      };
    case `${SEARCH_COMPANY_STRUCTURE}_${FAIL}`:
      return { ...state, isSearching: false, searchResults: [] };

    case GET_PERSON_DETAILS_REQUEST:
      return { ...state, isPersonDetailsLoading: true, selectedPerson: null };
    case `${GET_PERSON_DETAILS}_${SUCCESS}`:
      return {
        ...state,
        isPersonDetailsLoading: false,
        selectedPerson: payload,
      };
    case `${GET_PERSON_DETAILS}_${FAIL}`:
      return { ...state, isPersonDetailsLoading: false, selectedPerson: null };

    case GET_PERSON_EDIT_DATA:
      return { ...state, isPersonEditDataLoading: true, editData: null };
    case `${GET_PERSON_EDIT_DATA}_${SUCCESS}`:
      return {
        ...state,
        isPersonEditDataLoading: false,
        editData: payload,
      };
    case `${GET_PERSON_EDIT_DATA}_${FAIL}`:
      return { ...state, isPersonEditDataLoading: false, editData: null, error: { ...payload } };

    case UPDATE_PERSON_HIERARCHY:
      return { ...state, isUpdating: true, updateResult: null };
    case `${UPDATE_PERSON_HIERARCHY}_${SUCCESS}`:
      return {
        ...state,
        isUpdating: false,
        updateResult: payload,
      };
    case `${UPDATE_PERSON_HIERARCHY}_${FAIL}`:
      return {
        ...state,
        isUpdating: false,
        updateResult: null,
        error: { ...payload },
      };

    case GET_PERSON_HISTORY:
      return { ...state, isPersonHistoryLoading: true };
    case `${GET_PERSON_HISTORY}_${SUCCESS}`:
      return {
        ...state,
        isPersonHistoryLoading: false,
        personHistory: payload || [],
      };
    case `${GET_PERSON_HISTORY}_${FAIL}`:
      return { ...state, isPersonHistoryLoading: false, personHistory: [] };

    case CLEAR_PERSON_EDIT_DATA:
      return {
        ...state,
        editData: null,
        updateResult: null,
        personHistory: [],
      };

    default:
      return state;
  }
};
